import { useLayoutEffect } from 'preact/hooks';

export function useStopAdOnVideoEnd(videoSlot: HTMLVideoElement, stopVPAID: Function) {
  useLayoutEffect(() => {
    function onTimeUpdate() {
      if (videoSlot.duration - videoSlot.currentTime === 0) stopVPAID();
    }

    videoSlot.addEventListener('timeupdate', onTimeUpdate);
    return () => videoSlot.removeEventListener('timeupdate', onTimeUpdate);
  }, []);
}
